function getDisabledDataAttribute(disabled) {
  if (disabled === void 0 || disabled === false) {
    return;
  }
  return { ["data-disabled"]: "" };
}

export { getDisabledDataAttribute };
//# sourceMappingURL=getDisabledDataAttribute.mjs.map
